import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CsExpansionPanelModule,
  CsIconModule,
  CsTabsModule
} from '@cbuild/controls';
import {
  AbbrModule,
  FromUTCModule,
  LoadingModule,
  NameBadgeModule,
  SelectCheckBoxModule,
  SplitUrlModule
} from '@cbuild/shared';
import { LoginService } from '../../login/login.service';
import { CallCenterStatusComponent } from './call-center-status/call-center-status.component';
import { CallCenterModule } from './call-center/call-center.module';
import { NavMenuComponent } from './nav-menu.component';
import { NavMenuService } from './nav-menu.service';
import { NavProfileDropdownComponent } from './nav-profile-dropdown/nav-profile-dropdown.component';
import { NotificationService } from './notifications/notification.service';
import { NotificationsComponent } from './notifications/notifications.component';
import { ApplicantChangeRequestComponent } from './to-do/applicant-change-request/applicant-change-request.component';
import { CancelRequestComponent } from './to-do/cancel-request/cancel-request.component';
import { CommissionApprovalComponent } from './to-do/commission-approval/commission-approval.component';
import { DiscountRequestComponent } from './to-do/discount-request/discount-request.component';
import { DocumentRequestComponent } from './to-do/document-request/document-request.component';
import { KYCRequestsComponent } from './to-do/kyc-requests/kyc-requests.component';
import { LeadRequestsComponent } from './to-do/lead-requests/lead-requests.component';
import { MilestoneApprovalComponent } from './to-do/milestone-approval/milestone-approval.component';
import { PaymentRequestComponent } from './to-do/payment-request/payment-request.component';
import { PriceModificationsComponent } from './to-do/price-modifications/price-modifications.component';
import { TdsRequestsComponent } from './to-do/tds-requests/tds-requests.component';
import { ToDoComponent } from './to-do/to-do.component';
import { ToDoService } from './to-do/to-do.service';
import { UnitChangeRequestsComponent } from './to-do/unit-change-requests/unit-change-requests.component';
import { UnitCustomizationRequestsComponent } from './to-do/unit-customization-requests/unit-customization-requests.component';
import { WebLoaderComponent } from './web-loader/web-loader.component';
import { AiAssistantModule } from '@cbuild/shared';

@NgModule({
  declarations: [
    NavMenuComponent,
    NavProfileDropdownComponent,
    WebLoaderComponent,
    NotificationsComponent,
    CallCenterStatusComponent,
    ToDoComponent,
    DiscountRequestComponent,
    KYCRequestsComponent,
    PaymentRequestComponent,
    CancelRequestComponent,
    UnitChangeRequestsComponent,
    LeadRequestsComponent,
    ApplicantChangeRequestComponent,
    UnitCustomizationRequestsComponent,
    CommissionApprovalComponent,
    MilestoneApprovalComponent,
    TdsRequestsComponent,
    PriceModificationsComponent,
    DocumentRequestComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    CsIconModule,
    CallCenterModule,
    SplitUrlModule,
    CsExpansionPanelModule,
    SelectCheckBoxModule,
    FromUTCModule,
    CsTabsModule,
    LoadingModule,
    NameBadgeModule,
    AbbrModule,
    AiAssistantModule
  ],
  exports: [NavMenuComponent],
  providers: [NavMenuService, NotificationService, ToDoService, LoginService]
})
export class NavMenuModule {}
